import { environment } from '../../../environments/environment';
import { nativeConsole } from '../utils/disable-console-in-production';

export type DebugLogChannel = 'http' | 'router';

const SENSITIVE_KEY_PATTERN = /pass(word)?|token|secret|otp|pin/i;
const MASK = '***';

const CHANNEL_STYLE: Record<DebugLogChannel, string> = {
  http: 'color:#fff;background:#0ea5e9;padding:1px 6px;border-radius:4px;font-weight:600',
  router: 'color:#1e293b;background:#fbbf24;padding:1px 6px;border-radius:4px;font-weight:600',
};

export function isDebugLogEnabled(channel: DebugLogChannel): boolean {
  const config = environment.debugLog;
  return !!config?.enabled && !!config[channel];
}

export function isDebugPayloadEnabled(): boolean {
  return !!environment.debugLog?.payload;
}

/**
 * Deep-copy a payload with sensitive fields masked (password, token, ...).
 * ซ่อนค่าที่เป็นความลับก่อนพิมพ์ลง console
 */
export function maskSensitive(value: unknown, depth = 0): unknown {
  if (value === null || value === undefined || depth > 8) return value;
  if (typeof FormData !== 'undefined' && value instanceof FormData) return '[FormData]';
  if (typeof Blob !== 'undefined' && value instanceof Blob) return `[Blob ${value.size} bytes]`;
  if (Array.isArray(value)) return value.map((item: unknown) => maskSensitive(item, depth + 1));
  if (typeof value !== 'object') return value;

  const result: Record<string, unknown> = {};
  for (const [key, inner] of Object.entries(value as Record<string, unknown>)) {
    result[key] = SENSITIVE_KEY_PATTERN.test(key) ? MASK : maskSensitive(inner, depth + 1);
  }
  return result;
}

export function debugLog(channel: DebugLogChannel, title: string, details?: Record<string, unknown>): void {
  const time = new Date().toLocaleTimeString('en-GB', { hour12: false });
  const label = `%c${channel.toUpperCase()}%c ${time} ${title}`;

  if (!details) {
    nativeConsole.log(label, CHANNEL_STYLE[channel], '');
    return;
  }

  nativeConsole.groupCollapsed(label, CHANNEL_STYLE[channel], '');
  for (const [key, value] of Object.entries(details)) {
    nativeConsole.log(`${key}:`, value);
  }
  nativeConsole.groupEnd();
}
